// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #5b21b6;
    --backgroundLight: #fafaf9;
    --backgroundDark: #1e3a8a;
}

* {
    padding: 0;
    margin: 0;
    font-family: Verdana, Helvetica, Arial;
    text-align: center;
}

#root {
    height: 100vh;
    width: 100vw;
    overflow: none;
}

h1 {
    color: var(--primary);
    font-weight: 500;
    padding: 0.5em 0;
}

button {
    padding: 1em 2em;
    background-color: var(--primary);
    color: white;
    border: none;
    border-radius: 0.5em;
    margin: 0 0.5em;
}

input {
    padding: 0.5em;
    border-radius: 0.25em;
    border: 1px solid var(--primary);
}

.watchContainer {
    margin: 1em 0.5em;
    padding: 1em;
    border: 1px solid var(--primary);
    border-radius: 0.5em;
    display: flex;
    flex-direction: column;
    box-shadow:
        0 4px 6px -1px rgb(0 0 0 / 0.1),
        0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.light-bg {
    background-color: var(--backgroundLight);
    color: var(--primary);
}

.dark-bg {
    background-color: var(--backgroundDark);
    color: white;
}

.watchContainer>* {
    margin-top: 0.5em;
}

.timeLabel {
    font-size: 1.25em;
    line-height: 1.75em;
}

.subLabel {
    font-size: 1rem;
    line-height: 1.75rem;
}

@media (max-width: 600px) {
    #root {
        display: flex;
        flex-direction: column;
    }
    #root > *{
        margin-top: 0.25em;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,SAAS;IACT,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB;;uCAEmC;AACvC;;AAEA;IACI,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[":root {\n    --primary: #5b21b6;\n    --backgroundLight: #fafaf9;\n    --backgroundDark: #1e3a8a;\n}\n\n* {\n    padding: 0;\n    margin: 0;\n    font-family: Verdana, Helvetica, Arial;\n    text-align: center;\n}\n\n#root {\n    height: 100vh;\n    width: 100vw;\n    overflow: none;\n}\n\nh1 {\n    color: var(--primary);\n    font-weight: 500;\n    padding: 0.5em 0;\n}\n\nbutton {\n    padding: 1em 2em;\n    background-color: var(--primary);\n    color: white;\n    border: none;\n    border-radius: 0.5em;\n    margin: 0 0.5em;\n}\n\ninput {\n    padding: 0.5em;\n    border-radius: 0.25em;\n    border: 1px solid var(--primary);\n}\n\n.watchContainer {\n    margin: 1em 0.5em;\n    padding: 1em;\n    border: 1px solid var(--primary);\n    border-radius: 0.5em;\n    display: flex;\n    flex-direction: column;\n    box-shadow:\n        0 4px 6px -1px rgb(0 0 0 / 0.1),\n        0 2px 4px -2px rgb(0 0 0 / 0.1);\n}\n\n.light-bg {\n    background-color: var(--backgroundLight);\n    color: var(--primary);\n}\n\n.dark-bg {\n    background-color: var(--backgroundDark);\n    color: white;\n}\n\n.watchContainer>* {\n    margin-top: 0.5em;\n}\n\n.timeLabel {\n    font-size: 1.25em;\n    line-height: 1.75em;\n}\n\n.subLabel {\n    font-size: 1rem;\n    line-height: 1.75rem;\n}\n\n@media (max-width: 600px) {\n    #root {\n        display: flex;\n        flex-direction: column;\n    }\n    #root > *{\n        margin-top: 0.25em;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
